<!--
 * @Description: 
 * @Date: 2020-09-25 14:31:48
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="logo-box">
    <div class="logo">
      <img src="../../img/puzzle/logo-bg.png" class="b" alt />
      <img v-if="cLogo" :src="cLogo" alt class="c" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      cLogo: '', // require('../../img/puzzle/logo.png')
    };
  },
  computed: {},
  props: {
    logo: {
      type: String,
      default: ''
    }
  },
  created() {
    if (this.logo) {
      this.cLogo = this.logo;
    }
  },
  watch: {
    logo: {
      handler(newV) {
        this.cLogo = newV || '';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.logo-box {
  width: 3.573rem;
  height: 3.333rem;
  .logo {
    position: relative;
    .b {
      width: 100%;
      height: 100%;
    }
    .c {
      position: absolute;
      left: 0.853rem;
      top: 1.28rem;
      width: 2.04rem;
      height: 0.6rem;
      z-index: 2;
    }
  }
}
</style>
